<template>
  <!-- <div v-if="isModalVisible" class='login-wx'>
    
    <div class="qrcode" style="height: 300px;text-align: center;" id="qrcode-container"></div>
    <div class="help-btn"><span @click="wxScanHelp()">微信绑定账号操作说明</span></div>
  </div> -->
  <div v-if="isModalVisible" class="wx">
    <div class='login-wx'>
      <!-- 用vue-qriously生成二维码 -->
      <div class="qrcode" style="height: 285px;text-align: center;" id="qrcode-container"></div>

    </div>
    <div class="help-btn"><span @click="wxScanHelp()">微信绑定账号操作说明</span></div>
  </div>

</template>

<script>
import {
  getWebQRCode,
  pollingWebQRCodeLoginStatus,
} from '@/api/api.p'
const QRCode = require('qrcode');

export default {
  props: {
    visible: Boolean,
  },
  computed: {
    isModalVisible () {
      return this.visible;
    },
  },
  watch: {
    visible () {
      this.updateQr();
    }
  },
  mounted () {
    this.updateQr();
  },
  data () {
    return {
      url: '',// 二维码地址
      key: '',// 二维码的key
      timerCode: null,// 定时
      isRefresh: false,// 二维码是否过期
      qrcodeValue: '', // 将在后面生成二维码的内容赋给这个变量
    }
  },
  // 组件注销时停止轮询
  destroyed () {
    window.clearInterval(this.timerCode)
    this.timerCode = null
  },
  methods: {
    updateQr () {
      console.log(`updateQr: visible=${this.visible}`);
      if (this.visible) {
        this.getQrKey()
      } else {
        this.stop();
      }
    },
    // 获取key
    getQrKey () {
      console.log('getQrKey');
      getWebQRCode().then((res) => {

        if (res && res.meta && res.meta.code === 0) {
          console.log(44444444)
          this.key = res.data;
          let data = res.data;
          // this.makeQrCode();
          // 配置new WxLogin所需的选项
          var href = 'data:text/css;base64,LmltcG93ZXJCb3gge21hcmdpbi10b3A6LTIwcHg7IH0KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge2Rpc3BsYXk6bm9uZTt9Ci5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0KLmltcG93ZXJCb3ggLnFyY29kZXt3aWR0aDoyODBweDsgaGVpZ2h0OjI4MHB4O2JvcmRlcjpub25lO30='

          const wxLoginOptions = {
            self_redirect: true,
            id: "qrcode-container", // 确保有一个id为'canvas'的元素
            appid: data.appid, // 请替换为您的应用程序的App ID
            scope: data.scope,
            state: data.state, // 请替换为您的状态值
            redirect_uri: data.redirect_uri, // 请替换为您的回调URL

            href: href, // 这里修改微信二维码默认样式
          };

          const qrcodeContainer = document.getElementById("qrcode-container");
          qrcodeContainer.innerHTML = "";
          if (qrcodeContainer) {
            // 在这里执行生成二维码和 new WxLogin 的操作
            // 使用new WxLogin生成二维码并处理微信扫码登录
            new WxLogin(wxLoginOptions);
            this.lunxunData()
          } else {
            console.error("元素 'qrcode-container' 未找到。");
          }
        } else {
          const qrcodeContainer = document.getElementById("qrcode-container");
          qrcodeContainer.innerHTML = res.meta.message;
        }
      })
    },
    // 生成二维码
    makeQrCode () {
      let opts = {
        errorCorrectionLevel: 'H',
        type: 'image/png',
        quality: 0.3,
        width: 165,
        height: 165,
        // text: this.key,
        color: {
          dark: '#333333',
          light: '#fff'
        }
      }
      let key = {
        self_redirect: true,
        id: "canvas",
        appid: this.key.appid,
        scope: this.key.scope,
        state: this.key.state,
        redirect_uri: this.key.state,
      }
      QRCode.toCanvas(this.$refs.canvas, JSON.stringify(key), opts)
    },
    // 检查二维码状态
    checkQrCode () {
      let data = {
        state: this.key.state
      }
      pollingWebQRCodeLoginStatus(data)
        .then((res) => {
          if (res && res.meta) {
            if (res.meta.code === 0) {
              this.stop()
              this.$emit("afterLogin", res.data);
            } else if (res.meta.code === 71015) {
              this.stop()
              this.$toast(res.meta.message)
            } else if (res.meta.code === 71012) {
              this.stop()
              this.$toast(res.meta.message)
            }
          }
        })
        .catch((err) => {
          this.stop()
        })
    },
    // 轮询
    lunxunData () {
      this.timerCode = window.setInterval(() => {
        setTimeout(() => {
          this.checkQrCode()
        }, 0)
      }, 5000)
    },
    // 停止轮询
    stop () {
      window.clearInterval(this.timerCode)
      this.timerCode = null
    },
    // 刷新二维码
    refreshQrcode () {
      // 关闭二维码过期样式
      this.isRefresh = false
      this.getQrKey()
    },
    wxScanHelp () {
      console.log('wxScanHelp');
      this.$router.push({
        path: `/help/wxScanHelp.docx`
      })
    },
  },
}
</script>
<style lang="less" scoped>
// .login-wx {
//   min-width: 260px;
//   width: 100%;
//   // height: 316px;
//   height: 286px;

//   margin: 0 auto;
//   background: #fff;
//   color: #bfbfbf;
//   flex-direction: column;
//   align-items: center;

//   .codes-box {
//     width: 100%;
//     display: flex;
//     .codes-left {
//       flex: 1;
//     }
//     .code-btn {
//       flex: 1;
//       text-align: right;
//       cursor: pointer;
//       color: #606266;
//       font-weight: 500;
//       font-size: 14px;
//     }
//   }
//   .qrcode {
//     flex: 1;
//     height: 316px;
//   }
//   .help-btn {
//     flex: 1;
//     text-align: center;
//     cursor: pointer;
//     color: #606266;
//     font-weight: 500;
//     font-size: 14px;
//   }
// }
.wx {
  .help-btn {
    height: 20px;
    width: 100%;
    // flex: 1;
    text-align: center;
    cursor: pointer;
    color: #606266;
    font-weight: 500;
    font-size: 14px;
    span {
      text-align: center;
    }
  }
  .login-wx {
    min-width: 260px;
    width: 100%;
    height: 287px;
    margin: 0 auto;
    background: #fff;
    color: #bfbfbf;
    flex-direction: column;
    align-items: center;

    .codes-box {
      width: 100%;
      display: flex;
      .codes-left {
        flex: 1;
      }
      .code-btn {
        flex: 1;
        text-align: right;
        cursor: pointer;
        color: #606266;
        font-weight: 500;
        font-size: 14px;
      }
    }
    .qrcode {
      flex: 1;
      height: 285px;
    }
  }
}
</style>
<style >
iframe {
  /* height: 300px !important; */
  height: 286px !important;
}
</style>
